module.exports = __webpack_public_path__ + "static/img/img3-2.b6e711b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/202403/img3-2.jpg
// module id = M9uY
// module chunks = 0